import React from "react";
// React Table
import { Container, Table, Row, Col } from "react-bootstrap";
// Utils
import { formatDate } from "../../../../utils";
// Styled Components
import styled from "styled-components";
// Contexto
import { categoriaMisiones, workCategories } from "../../../../contexto";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaInfoMision = ({ datosMision }) => {
  return (
    <Container>
      <Row>
        <Col>
          <b>Información principal</b>
          <Table bordered responsive>
            <tbody>
              <tr>
                <CustomTd className={"w-50"}>
                  <span>Nombre</span>
                </CustomTd>
                <td>{datosMision?.name || <small>No especificado</small>}</td>
              </tr>
              <tr>
                <CustomTd>
                  <span>Clave</span>
                </CustomTd>
                <td>{datosMision?.key || <small>No especificado</small>}</td>
              </tr>
              <tr>
                <CustomTd>
                  <span>En colaboración</span>
                </CustomTd>
                <td>{datosMision?.isCollaborative ? "Sí" : "No"}</td>
              </tr>
              <tr>
                <CustomTd>
                  <span>Tipo</span>
                </CustomTd>
                <td>{datosMision?.type ? datosMision?.type + (!(datosMision?.isCollaborative) ? " STJ" : '') : <small>No especificado</small>}</td>
              </tr>
              <tr>
                <CustomTd>
                  <span>Contexto</span>
                </CustomTd>
                <td>{datosMision?.context?.type || <small>No especificado</small>}</td>
              </tr>
              <tr>
                <CustomTd>
                  <span>Categoría</span>
                </CustomTd>
                <td>{categoriaMisiones[datosMision?.category] || <small>No especificado</small>}</td>
              </tr>
              {datosMision?.category === workCategories[1] && (
                <tr>
                  <CustomTd>
                    <span>Capacidad</span>
                  </CustomTd>
                  <td>{datosMision?.maxCap || <small>No especificado</small>}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
        <Col>
          <b>Dirección</b>
          <Table bordered responsive>
            <tbody>
              <tr>
                <CustomTd className={"w-50"}>
                  <span>País</span>
                </CustomTd>
                <td>{datosMision?.country || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd className={"w-50"}>
                  <span>Provincia-Estado</span>
                </CustomTd>
                <td>{datosMision?.provinceAddress || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Código postal</span>
                </CustomTd>
                <td>{datosMision?.postcode || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Localidad</span>
                </CustomTd>
                <td>{datosMision?.place || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Calle</span>
                </CustomTd>
                <td>{datosMision?.address || <small>No especificado</small>}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          <b>Estado</b>
          <Table bordered responsive>
            <tbody>
              <tr>
                <CustomTd>
                  <span>Fecha de apertura</span>
                </CustomTd>
                <td>{formatDate(datosMision?.startDate) || <small>No especificado</small>}</td>
              </tr>
              <tr>
                <CustomTd>
                  <span>Fecha de cierre</span>
                </CustomTd>
                <td>{formatDate(datosMision?.endDate) || <small>No especificado</small>}</td>
              </tr>
              {datosMision?.cessionDate && (
                <tr>
                  <CustomTd className={"w-50"}>
                    <span>Fecha de cesión</span>
                  </CustomTd>
                  <td>{formatDate(datosMision?.cessionDate) || <small>No especificado</small>}</td>
                </tr>
              )}
              {datosMision?.cessionTo && (
                <tr>
                  <CustomTd className={"w-50"}>
                    <span>Entidad cedida</span>
                  </CustomTd>
                  <td>{datosMision?.cessionTo || <small>No especificado</small>}</td>
                </tr>
              )}
            </tbody>
          </Table>
          <b>Calendario actividades</b>
          <Table bordered responsive>
            <tbody>
              <tr>
                <CustomTd className={"w-50"}>
                  <span>Fecha inicial</span>
                </CustomTd>
                <td>{formatDate(datosMision?.activityStart) || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Fecha final</span>
                </CustomTd>
                <td>{formatDate(datosMision?.activityEnd) || <small>No especificado</small>}</td>
              </tr>
            </tbody>
          </Table>
        </Col>

        <Col>
          <b>Datos contacto</b>
          <Table bordered responsive>
            <tbody>
              <tr>
                <CustomTd className={"w-50"}>
                  <span>Teléfono</span>
                </CustomTd>
                <td>{datosMision?.telephone || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Email</span>
                </CustomTd>
                <td>{datosMision?.email || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Web</span>
                </CustomTd>
                <td>{datosMision?.web || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd>
                  <span>Redes</span>
                </CustomTd>
                <td>{datosMision?.RRSS || <small>No especificado</small>}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          {datosMision.isCollaborative &&
            (datosMision.type === "Obra" ? (
              <>
                <b>Personal</b>
                <Table bordered responsive>
                  <tbody>
                    <tr>
                      <CustomTd className={"w-50"}>
                        <span>Número de hermanas que trabajan en la obra</span>
                      </CustomTd>
                      <td>{datosMision?.nSisterCollaborative || <small>No especificado</small>}</td>
                    </tr>

                    <tr>
                      <CustomTd>
                        <span>Población atendida</span>
                      </CustomTd>
                      <td>{datosMision?.peopleAttendedCollaborative || <small>No especificado</small>}</td>
                    </tr>
                  </tbody>
                </Table>
              </>
            ) : (
              <>
                <b>Personal</b>
                <Table bordered responsive>
                  <tbody>
                    <tr>
                      <CustomTd className={"w-50"}>
                        <span>Número de hermanas que trabajan en la obra</span>
                      </CustomTd>
                      <td>{datosMision?.nSisterCollaborative || <small>No especificado</small>}</td>
                    </tr>
                  </tbody>
                </Table>
              </>
            ))}
        </Col>
      </Row>
    </Container>
  );
};

export default VistaInfoMision;
